import script from "./DetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailView.vue?vue&type=script&setup=true&lang=ts"

import "./DetailView.vue?vue&type=style&index=0&id=17b55d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b55d06"]])

export default __exports__